module.exports = __webpack_public_path__ + "img/mzh.900c6b39.png";